module.exports = __webpack_public_path__ + "img/wxpay.56df21f1.png";